import { render, staticRenderFns } from "./SaleProductList.vue?vue&type=template&id=24ea7104&"
import script from "./SaleProductList.vue?vue&type=script&lang=js&"
export * from "./SaleProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports